import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {Util} from 'reactstrap'
import styles from './Input.module.css'


const {mapToCssModules, deprecated, warnOnce} = Util

const propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    size: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    infoText: PropTypes.string,
    normalized: PropTypes.bool,
    bsSize: PropTypes.string,
    state: deprecated(
        PropTypes.string,
        'Please use the props "valid" and "invalid" to indicate the state.'
    ),
    valid: PropTypes.bool,
    invalid: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onChange: PropTypes.func,
    onValidate: PropTypes.number,
    innerRef: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
        PropTypes.string
    ]),
    static: deprecated(PropTypes.bool, 'Please use the prop "plaintext"'),
    plaintext: PropTypes.bool,
    addon: PropTypes.bool,
    className: PropTypes.any,
    styleErrorMessage: PropTypes.string,
    spanStyle: PropTypes.object,
    cssModule: PropTypes.object,
    errorMessage: PropTypes.string
}

const defaultProps = {
    type: 'text',
    autoComplete: 'off',
}

class Input extends React.Component {

    state = {
        isFocused: false,
        hidden: true,
        icon: true,
        className: this.props.className,
        timeout: null,
        hasChanged: false
    }

    constructor(props) {
        super(props)

        this.toggleShow = this.toggleShow.bind(this)
    }

    componentDidMount() {
        if (this.props.value !== null || this.props.value !== undefined || this.props.value !== "") {
            this.setState({value: this.props.value})
        }

        if (this.props.type == "number") {
            let invalidChars = ["-", "+", "e", "=", "_"];
            document.getElementById(this.props.id).addEventListener("keydown", function (e) {
                if (invalidChars.includes(e.key)) {
                    e.preventDefault();
                }
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {

            if (this.props.onValidate) {
                let ret = this.props.onValidate;
                if (ret) {
                    if (ret == 1) {
                        this.setState({
                            className: this.addErrorClass(),
                            errorMessage: this.props.errorMessage,
                            styleErrorMessage: 'inline'
                        });
                    } else if (ret == 2) {
                        this.setState({
                            className: this.removeErrorClass(),
                            errorMessage: "",
                            styleErrorMessage: 'none'
                        });
                    }
                }
            }


        }
    }


    invokeValidate = (val) => {

        if (this.props.onValidate) {
            let ret = this.props.onValidate
            if (ret) {
                if (ret == 1) {
                    this.setState({
                        className: this.addErrorClass(),
                        errorMessage: this.props.errorMessage,
                        styleErrorMessage: 'inline'
                    })
                } else if (ret == 2) {
                    this.setState({
                        className: this.removeErrorClass(),
                        errorMessage: "",
                        styleErrorMessage: 'none'
                    })
                } else {
                    this.setState({className: this.removeErrorClass(), errorMessage: '', styleErrorMessage: 'none'})
                }
            } else {
                this.setState({className: this.removeErrorClass(), errorMessage: '', styleErrorMessage: 'none'})
            }
        } else {
            this.setState({className: this.removeErrorClass(), errorMessage: '', styleErrorMessage: 'none'})
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: {value: val}
            })
        }
    }

    handleOnChange = (e) => {
        let that = this
        let val = e.target.value

        if (this.props.type === "number" && val !== "" && val !== null) {
            let {min, max} = e.target;
            if ((min || min === "0") && (max || max === "0")) {
                val = Math.max(Number(min), Math.min(Number(max), Number(val)));
            } else if ((!min && min !== "0") && (max || max === "0")) {
                val = Math.min(Number(max), Number(val));
            } else if ((min || min === "0") && (!max && max !== "0")) {
                val = Math.max(Number(min), Number(val));
            }
        }


        this.setState({value: val})

        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: {value: val}
            })
        }

        if (this.state.timeout) {
            clearTimeout(this.state.timeout)
        }
        this.state.timeout = setTimeout(() => that.invokeValidate(val), 300)
    }

    removeErrorClass = () => {
        if (typeof (this.state.className) === 'string') {
            this.state.className = "txtInput"
        } else if (Array.isArray(this.state.className)) {
            if (this.state.className.regexIndexOf('errorBorder') != -1) this.state.className.splice(this.state.className.regexIndexOf('errorBorder'), 1)
            if (this.state.className.regexIndexOf('txtInput') == -1) this.state.className.push("txtInput")
        }
        return this.state.className
    }

    addErrorClass = () => {
        if (typeof (this.state.className) === 'string') {
            this.state.className = styles.errorBorder
        } else if (Array.isArray(this.state.className)) {
            if (this.state.className.regexIndexOf('txtInput') != -1) this.state.className.splice(this.state.className.regexIndexOf('txtInput'), 1)
            if (this.state.className.regexIndexOf('errorBorder') == -1) this.state.className.push(styles.errorBorder)
        }
        return this.state.className
    }

    toggleFocusLabel = () => {
        this.setState({
            isFocused: true
        })
    }

    toggleBlurLabel = e => {

        if(this.props.onBlur!==undefined) this.props.onBlur();

        if (e.target.value === '') {
            this.setState({
                isFocused: !this.state.isFocused
            })
        }
    }

    toggleShow() {
        this.setState({hidden: !this.state.hidden, icon: !this.state.icon})
    }

    render() {
        const {
            cssModule,
            parentClass,
            type,
            state,
            tag,
            addon,
            static: staticInput,
            plaintext,
            innerRef,
            label,
            infoText,
            infoTextControlClass,
            placeholder,
            normalized,
            value,
            onValidate,
            spanStyle,
            ...attributes
        } = this.props
        let {bsSize, valid, invalid} = this.props

        if (!this.state.className) {
            this.state.className = ''
        }
        if (this.state.className.regexIndexOf('errorBorder') == -1) {
            this.removeErrorClass()
        }

        const checkInput = ['radio', 'checkbox'].indexOf(type) > -1
        const isNotNumber = new RegExp('\\D', 'g')

        const fileInput = type === 'file'
        const textareaInput = type === 'textarea'
        const selectInput = type === 'select'
        let Tag = tag || (selectInput || textareaInput ? type : 'input')

        let formControlClass = 'form-control'

        if (plaintext || staticInput) {
            formControlClass = `${formControlClass}-plaintext`
            Tag = tag || 'p'
        } else if (fileInput) {
            formControlClass = `${formControlClass}-file`
        } else if (checkInput) {
            if (addon) {
                formControlClass = null
            }
        }

        if (
            state &&
            typeof valid === 'undefined' &&
            typeof invalid === 'undefined'
        ) {
            if (state === 'danger') {
                invalid = true
            } else if (state === 'success') {
                valid = true
            }
        }

        if (attributes.size && isNotNumber.test(attributes.size)) {
            warnOnce(
                'Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.'
            )
            bsSize = attributes.size
            delete attributes.size
        }

        let classes = mapToCssModules(
            classNames(
                this.state.className,
                invalid && 'is-invalid',
                valid && 'is-valid',
                bsSize ? `form-control-${bsSize}` : false,
                formControlClass,
                this.props.required ? styles.placeholder : ""
            ),
            cssModule
        )

        let wrapperClass = mapToCssModules(
            classNames(
                parentClass
            ),
            cssModule
        );


        if (Tag === 'input' || typeof tag !== 'string') {
            attributes.type = type
        }

        if (
            attributes.children &&
            !(
                plaintext ||
                staticInput ||
                type === 'select' ||
                typeof Tag !== 'string' ||
                Tag === 'select'
            )
        ) {
            warnOnce(
                `Input with a type of "${type}" cannot have children. Please use "value"/"defaultValue" instead.`
            )
            delete attributes.children
        }

        let spanErrorMessage = <span style={{'display': this.state.styleErrorMessage}}
                                     className="invalid-feedback">{this.state.errorMessage}</span>

        let divSpan = <div style={spanStyle}>
            {spanErrorMessage}
        </div>

        classes = this.props.noOpacityOnDisabled ? [classes, "noOpacityOnDisabled"].join(" ").replace("txtInput", "") : classes
        classes = [classes, "elemento-visualizzazione"].join(" ")
        if (placeholder || value) {
            return (
                <div className={wrapperClass}>
                    <Tag
                        {...attributes}
                        autoComplete={this.props.autoComplete}
                        ref={innerRef}
                        className={classes}
                        id={this.props.id}
                        oninput={this.props.oninput}
                        onChange={e => this.handleOnChange(e)}
                        onFocus={this.props.onFocus ? this.props.onFocus : this.toggleFocusLabel}
                        onBlur={e => this.toggleBlurLabel(e)}
                        placeholder={this.props.required ? this.props.placeholder + "*" : this.props.placeholder}
                        value={this.props.value}
                        min={this.props.min ? this.props.min : null}
                        max={this.props.max ? this.props.max : null}
                        maxLength={this.props.maxLength ? this.props.maxLength : null}
                        step={this.props.step ? this.props.step : null}
                    />
                    {divSpan}
                </div>
            )
        }
        if (attributes.type === 'password') {
            return (
                <div className={wrapperClass}>
                    <Tag
                        {...attributes}
                        autoComplete={this.props.autoComplete}
                        ref={innerRef}
                        type={this.state.hidden ? 'password' : 'text'}
                        className={
                            this.state.isFocused
                                ? 'form-control input-password focus--mouse'
                                : 'form-control input-password'
                        }
                        onChange={e => this.handleOnChange(e)}
                        onFocus={this.props.onFocus ? this.props.onFocus : this.toggleFocusLabel}
                        onBlur={e => this.toggleBlurLabel(e)}
                        id={this.props.id}
                        placeholder={this.props.placeholder}
                        value={this.props.value}
                    />
                    <span className="password-icon" aria-hidden="true">
                        <svg
                            className="password-icon-visible icon icon-sm"
                            onClick={this.toggleShow}>
                          <use
                              xlinkHref={`/svg/sprite.svg#it-password-${
                                  this.state.icon ? 'visible' : 'invisible'
                              }`}
                          />
                        </svg>
                  </span>
                    <label
                        htmlFor={this.props.id}
                        className={this.state.isFocused ? 'active' : ''}>
                        {this.props.label}
                    </label>
                    {divSpan}
                </div>
            )
        }
        if (normalized) {
            return (
                <div className={wrapperClass}>
                    <Tag
                        {...attributes}
                        autoComplete={this.props.autoComplete}
                        className={
                            this.state.isFocused
                                ? 'form-control-plaintext focus--mouse'
                                : 'form-control-plaintext'
                        }
                        onChange={e => this.handleOnChange(e)}
                        onFocus={this.props.onFocus ? this.props.onFocus : this.toggleFocusLabel}
                        onBlur={e => this.toggleBlurLabel(e)}
                        id={this.props.id}
                        value={this.props.value}
                        readOnly
                    />
                    <label
                        htmlFor={this.props.id}
                        className={this.state.isFocused ? 'active' : ''}>
                        {this.props.label}
                    </label>
                    {divSpan}
                </div>
            )
        }
        if (label || infoText) {
            return (
                <div className={wrapperClass}>
                    <Tag
                        {...attributes}
                        autoComplete={this.props.autoComplete}
                        ref={innerRef}
                        className={classes}
                        id={this.props.id}
                        onChange={e => this.handleOnChange(e)}
                        onFocus={this.props.onFocus ? this.props.onFocus : this.toggleFocusLabel}
                        onBlur={e => this.toggleBlurLabel(e)}
                        value={this.props.value}
                        disabled={this.props.disabled}
                    />
                    <label
                        htmlFor={this.props.id}
                        className={this.state.isFocused ? 'active' : ''}>
                        {this.props.label}
                    </label>
                    {divSpan}
                </div>
            )
        }

        return <Tag {...attributes}
                    autoComplete={this.props.autoComplete}
                    onChange={e => this.handleOnChange(e)}
                    ref={innerRef} className={classes}/>
    }
}

Input.propTypes = propTypes
Input.defaultProps = defaultProps

export default Input
